let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2dJY0")).then(() => parcelRequire('jzfzn'));